/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCoolingRegimeGenusDtoFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeCoolingRegimeGenusDto, serializeUpsertCommand5, type CoolingRegimeGenusDto, type ProblemDetails, type UpsertCommand5, type ValidationProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { ByCodeRequestBuilderNavigationMetadata, type ByCodeRequestBuilder } from './byCode/index.js';
// @ts-ignore
import { CoolingRegimeGenusItemRequestBuilderRequestsMetadata, type CoolingRegimeGenusItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}/CoolingRegimeGenus
 */
export interface CoolingRegimeGenusRequestBuilder extends BaseRequestBuilder<CoolingRegimeGenusRequestBuilder> {
    /**
     * The ByCode property
     */
    get byCode(): ByCodeRequestBuilder;
    /**
     * Gets an item from the Kiota.TypeScript.Api.api.vWithVersion.CoolingRegimeGenus.item collection
     * @param id The identifier.
     * @returns {CoolingRegimeGenusItemRequestBuilder}
     */
     byId(id: number) : CoolingRegimeGenusItemRequestBuilder;
    /**
     * Query settings:MaxExpansionDepth = 0, MaxSkip = 2147483647, MaxTop = 1000, PageSize = 1000
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CoolingRegimeGenusDto[]>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 405 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     * @throws {ProblemDetails} error when the service returns a 502 status code
     * @throws {ProblemDetails} error when the service returns a 503 status code
     * @throws {ProblemDetails} error when the service returns a 504 status code
     */
     get(requestConfiguration?: RequestConfiguration<CoolingRegimeGenusRequestBuilderGetQueryParameters> | undefined) : Promise<CoolingRegimeGenusDto[] | undefined>;
    /**
     * @param body Class UpsertCommand.Implements the CoolingRegimeGenusDto            
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CoolingRegimeGenusDto>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 405 status code
     * @throws {ProblemDetails} error when the service returns a 429 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     * @throws {ProblemDetails} error when the service returns a 502 status code
     * @throws {ProblemDetails} error when the service returns a 503 status code
     * @throws {ProblemDetails} error when the service returns a 504 status code
     */
     post(body: UpsertCommand5, requestConfiguration?: RequestConfiguration<CoolingRegimeGenusRequestBuilderPostQueryParameters> | undefined) : Promise<CoolingRegimeGenusDto | undefined>;
    /**
     * Query settings:MaxExpansionDepth = 0, MaxSkip = 2147483647, MaxTop = 1000, PageSize = 1000
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CoolingRegimeGenusRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body Class UpsertCommand.Implements the CoolingRegimeGenusDto            
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: UpsertCommand5, requestConfiguration?: RequestConfiguration<CoolingRegimeGenusRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
/**
 * Query settings:MaxExpansionDepth = 0, MaxSkip = 2147483647, MaxTop = 1000, PageSize = 1000
 */
export interface CoolingRegimeGenusRequestBuilderGetQueryParameters {
    /**
     * Filter the results using OData syntax.
     */
    filter?: string;
    /**
     * Order the results using OData syntax.
     */
    orderby?: string;
    /**
     * Skip the number of results returned.
     */
    skip?: number;
    /**
     * Limit the number of results returned.
     */
    top?: number;
}
export interface CoolingRegimeGenusRequestBuilderPostQueryParameters {
    culture?: string;
}
/**
 * Uri template for the request builder.
 */
export const CoolingRegimeGenusRequestBuilderUriTemplate = "{+baseurl}/api/v{version}/CoolingRegimeGenus{?%24filter*,%24orderby*,%24skip*,%24top*,culture*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const CoolingRegimeGenusRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "filter": "%24filter",
    "orderby": "%24orderby",
    "skip": "%24skip",
    "top": "%24top",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CoolingRegimeGenusRequestBuilderNavigationMetadata: Record<Exclude<keyof CoolingRegimeGenusRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: CoolingRegimeGenusItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
    byCode: {
        navigationMetadata: ByCodeRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CoolingRegimeGenusRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CoolingRegimeGenusRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            405: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            502: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            504: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCoolingRegimeGenusDtoFromDiscriminatorValue,
        queryParametersMapper: CoolingRegimeGenusRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: CoolingRegimeGenusRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            405: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            502: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            504: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCoolingRegimeGenusDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpsertCommand5,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
